import { Button } from "antd";
import classNames from "classnames";

import { getButtonText } from "./ListLoadMoreButton.helper";

const ListLoadMoreButton = ({ pagination, itemName, ...buttonProps }) => {
  const className = classNames("list-load-more-button", buttonProps.className);
  const text = getButtonText(pagination, itemName);

  if (!text) return null;

  return (
    <Button {...buttonProps} className={className}>
      {text}
    </Button>
  );
};

export default ListLoadMoreButton;
